export default {
  title: '商户管理',
  companyInfo: '企业信息',
  emailConfig: '邮箱配置',
  smsConfig: '短信配置',
  i18nManagement: '多语言管理',
  paymentAuthConfig: '支付与授权配置',
  systemSettings: '系统设置',
  roleManagement: '角色管理',
  accountManagement: '账号管理',
  operationLog: '操作日志',
  companyName: '公司名称',
  companyNameReadonly: '企业信息',
  companyNameReadonlyTip: '输入该语言环境下的公司展示名称',
  companyLogo: '公司 Logo',
  companyLogoTip: '限制图片格式（JPG、PNG）和大小（不超过5MB），上传后显示缩略图并支持替换',
  companyLocaleLabel: '公司资料',
  companyEmail: '公司邮箱',
  companyEmailPlaceholder: '请输入公司邮箱',
  companyPhone: '公司电话',
  companyPhonePlaceholder: '请输入联系电话',
  companyAddress: '公司地址',
  companyAddressPlaceholder: '请输入公司地址',
  companyIntro: '公司介绍',
  companyIntroPlaceholder: '请输入公司介绍',
  save: '保存',
  saveSuccess: '保存成功',
  uploadSuccess: '上传成功',
  uploadFail: '上传失败',
  logoFormatError: '仅支持 JPG、PNG 格式图片',
  logoSizeError: '图片大小不能超过 5MB',
  locale_zh_TW: '繁体中文',
  locale_zh_CN: '简体中文',
  locale_en_US: 'English',
  locale_ja_JP: 'Japanese',
};
